import { Button } from "@jugl-web/ui-components/cross-platform/Button";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { ReactComponent as CogIcon } from "./assets/cog.svg";

export const InvoicesHeaderRightContent = () => {
  const { t } = useTranslations();
  const title = t({
    id: "invoices-item-form-page.settings",
    defaultMessage: "Settings",
  });
  const { navigateToPage } = useNavigation();

  return (
    <Button
      onClick={() => navigateToPage("invoicesSettingsBusinessInformation")}
      variant="text"
      color="grey"
      iconStart={<CogIcon />}
    >
      {title}
    </Button>
  );
};
